import styled from 'styled-components';
import {BaseUnstyledLink} from './BaseUnstyledLink';

export const UnstyledLink = styled(BaseUnstyledLink)`
  &,
  &:hover,
  &:visited {
    text-decoration: none;
    color: inherit;
  }
`;
